// Catch-up pass for images that broke before the head.jinja error listener
// was registered (edge case: cached 404s resolved synchronously).
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("img").forEach(function (img) {
    if (img.dataset.brokenHandled) return;
    if (img.hasAttribute("data-no-broken")) return;
    var src = img.getAttribute("src");
    if (!src || src === "" || src === "#") return;
    if (img.complete && img.naturalWidth === 0) {
      img.dataset.brokenHandled = "1";
      img.style.visibility = "hidden";
      var p = img.parentElement;
      if (p) {
        p.style.backgroundColor = "var(--color-surface, #f8f9fa)";
        p.style.position = "relative";
        var ic = document.createElement("div");
        ic.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:var(--color-border,#e2e8f0);font-size:2rem;pointer-events:none;";
        ic.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
        p.appendChild(ic);
      }
    }
  });
});
